import httpClient from './httpClient';

export default {
  getModels: (apiKey, externalId, language) =>
    httpClient.get(`/api/build-and-price/${apiKey}/${externalId}/models?language=${language}`),
  getTrims: (apiKey, externalId, modelId, language) =>
    httpClient.get(`/api/build-and-price/${apiKey}/${externalId}/models/${modelId}/trims?language=${language}`),
  getConfig: (apiKey, externalId, trimId, language) =>
    httpClient.get(
      `/api/build-and-price/${apiKey}/${externalId}/trims/${trimId}/vehicleConfiguration?language=${language}`
    ),
  toggleVehicleOption: (apiKey, externalId, payload, language) =>
    httpClient.post(`/api/build-and-price/${apiKey}/${externalId}/toggleVehicleOption?language=${language}`, payload),
};
